export enum InputActionTypes {
  UPDATE_IS_VALID = 'UPDATE_IS_VALID',
  UPDATE_INPUT_FILTER = 'UPDATE_INPUT_FILTER',
  UPDATE_INPUT_BASIC_COLOR = 'UPDATE_INPUT_BASIC_COLOR',
  UPDATE_ACTIVE_INPUT_TYPE = 'UPDATE_ACTIVE_INPUT_TYPE',
}
